import { render, staticRenderFns } from "./DetalleEmergenciaSection.vue?vue&type=template&id=5621b7ef&scoped=true&"
import script from "./DetalleEmergenciaSection.vue?vue&type=script&lang=js&"
export * from "./DetalleEmergenciaSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5621b7ef",
  null
  
)

export default component.exports